import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent  } from './forgot-password.component';


const routes: Routes = [
    { path: 'forgotPassword', pathMatch: 'full', component:  ForgotPasswordComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgotPasswordRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password-routing.module.ts